import React, { useEffect, useState } from 'react'
import CustomTitle from '../../../components/UI/title/CustomTitle'
import { useDispatch, useSelector } from 'react-redux';
import { setButtonBackIsShow, setButtonClick } from '../../../store/buttonSlice';
import useMixpanel from '../../../hooks/useMixpanel';
import { useCheckEmailMutation } from '../../../api/dataApi';

export default function CheckEmail({ setError, setPageComponent, setButtonStatus, error, inputEmail, setInputEmail, setButtonText }) {

  const [checkEmailMutation] = useCheckEmailMutation();

  const buttonClicked = useSelector((state) => state.button.buttonClicked);
  const dispatch = useDispatch();
  const { trackP1Event } = useMixpanel();
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i;

  const [errorMessage, setErrorMessage] = useState('');



  useEffect(() => {
    dispatch(setButtonBackIsShow(false));
    setError(false)
  }, [])


  const [wrongEmail, setWrongEmail] = useState(false);
  const [noEmail, setNoEmail] = useState(false);

  useEffect(() => {
    setButtonText('Continue');
    if (buttonClicked) {

      if (inputEmail.length === 0) {
        setErrorMessage('Please, enter your email');
        setError(true);
        // setTimeout(() => {
        //   setError(false);
        // }, 1000);
        setNoEmail(true);
        setTimeout(() => {
          dispatch(setButtonClick(false));
        }, 100);
        return
      }
      if (!emailRegex.test(inputEmail)) {
        setError(true);
        setErrorMessage('Please, enter correct email');
        setWrongEmail(true);
        // setTimeout(() => {
        //   setError(false);
        // }, 1000);
      } else {
        setError(false);

        setButtonStatus('load');
        checkEmail()
      }
      setTimeout(() => {
        dispatch(setButtonClick(false));
      }, 100);
    }

  }, [buttonClicked]);


  const checkEmail = async () => {
    try {

      const response = await checkEmailMutation(inputEmail).unwrap();
      console.log(response);
      const isRegistered = response.data.isRegistered;


      if (isRegistered) {
        trackP1Event('web_signup', {
          web_entrance: 'login',
          email_success: "TRUE",
          error_reason: [
            wrongEmail && "wrong_email",
            noEmail && "no_email"
          ].filter(Boolean).join(",") || "none"
        })
        setPageComponent("loginEmail");


      } else {
        trackP1Event('web_signup', {
          web_entrance: 'signup',
          email_success: "TRUE",
          error_reason: [
            wrongEmail && "wrong_email",
            noEmail && "no_email"
          ].filter(Boolean).join(",") || "none"
        })
        setPageComponent("signupEmail");

      }
      setButtonStatus("");

    } catch (err) {

    }
  };

  return (
    <div style={{ paddingBottom: '36rem' }}>
      <CustomTitle style={{ marginBottom: "12rem" }} title={'Enter your email to start creating with Zeely'} />
      <p className="text" style={{ marginBottom: '24rem' }}>
        Sign in to access best AI models in one place.
      </p>
      <div className={`input ${error ? 'error' : ''}`}>
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.80569 3.35547L14.412 3.35674C15.5369 3.37038 16.1238 3.49595 16.7325 3.82151C17.3226 4.13709 17.7899 4.60446 18.1055 5.19455C18.4514 5.84132 18.5716 6.46345 18.5716 7.73245V13.2642C18.5716 14.5332 18.4514 15.1553 18.1055 15.8021C17.7899 16.3922 17.3226 16.8596 16.7325 17.1751C16.0857 17.521 15.4636 17.6412 14.1946 17.6412H5.80569C4.53669 17.6412 3.91456 17.521 3.26779 17.1751C2.6777 16.8596 2.21033 16.3922 1.89475 15.8021C1.54885 15.1553 1.42871 14.5332 1.42871 13.2642L1.42998 7.51508C1.44363 6.39017 1.5692 5.80328 1.89475 5.19455C2.21033 4.60446 2.6777 4.13709 3.26779 3.82151C3.91456 3.47561 4.53669 3.35547 5.80569 3.35547ZM16.9195 6.01834L12.0204 10.9167C10.9419 11.9953 9.21545 12.0313 8.09367 11.0246L7.97983 10.9167L3.08073 6.01834C2.91686 6.38603 2.85728 6.80661 2.85728 7.73245V13.2642C2.85728 14.3175 2.9344 14.7169 3.15448 15.1284C3.33692 15.4695 3.60037 15.733 3.9415 15.9154C4.30461 16.1096 4.65823 16.1925 5.46 16.2093L5.80569 16.2126H14.1946C15.2479 16.2126 15.6473 16.1355 16.0588 15.9154C16.3999 15.733 16.6634 15.4695 16.8458 15.1284C17.04 14.7653 17.1229 14.4117 17.1397 13.6099L17.143 13.2642V7.73245C17.143 6.80661 17.0834 6.38603 16.9195 6.01834ZM14.1946 4.78404H5.80569C4.87985 4.78404 4.45928 4.84362 4.09158 5.00749L8.98999 9.90659C9.51852 10.4351 10.3581 10.4629 10.9194 9.99004L11.0103 9.90659L15.9087 5.00749C15.541 4.84362 15.1204 4.78404 14.1946 4.78404Z" fill="#CAD4DD" />
        </svg>
        <input
          type="email"
          value={inputEmail}
          onChange={(e) => {
            setInputEmail(e.target.value.toLowerCase())
            setError(false)
          }}
          onFocus={() => {
            trackP1Event('web_signup_input', {

            })
          }}
          style={{
            paddingLeft: "46rem",
          }} placeholder='Add your email'
          name='email1'

        />
        {error && (
          <div className="error-text">
            {errorMessage}
          </div>
        )}
      </div>
      <div className="signup-greenText">
        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.59239 2.76746C5.76592 2.44073 6.23408 2.44073 6.40761 2.76746L7.73523 5.26712C7.80194 5.39272 7.92284 5.48056 8.06291 5.50519L10.8505 5.99539C11.2148 6.05947 11.3595 6.50472 11.1024 6.77072L9.13534 8.8058C9.0365 8.90806 8.99032 9.05018 9.01018 9.191L9.40538 11.9936C9.45703 12.36 9.07828 12.6351 8.74584 12.4728L6.20252 11.2309C6.07472 11.1685 5.92528 11.1685 5.79748 11.2309L3.25416 12.4728C2.92172 12.6351 2.54297 12.36 2.59462 11.9936L2.98982 9.191C3.00968 9.05018 2.9635 8.90806 2.86466 8.8058L0.897602 6.77072C0.640488 6.50472 0.785158 6.05947 1.14952 5.99539L3.93709 5.50519C4.07716 5.48056 4.19806 5.39272 4.26477 5.26712L5.59239 2.76746Z" fill="black" />
        </svg>

        1 million+ businesses and creators have chosen us.
      </div>
    </div>
  )
}
